/*
Validation rules:
Mandatory fields:
First name is required
Last name is required
Date of birth is required
Phone number is required
Phone number must be 8 - 15 digits
Phone number must be in the format 04xx xxx xxx
Phone number type is required
Legal issue is required
Matter description is required
Matter description must be at least 10 characters
Matter description must contain at least 5 words

Warnings:
Email must be valid if provided
Email is optional
Disability list must contain between 1 - 4 items
Disability list is optional

If the form is in pristine state, the submit button is disabled
if the form is in pristine state warning badges are not displayed
If the form is in pristine state, the warning count is 0
if a field is dirty or touched and invalid, the error or warning count is updated and badges are displayed
if an invalid field is dirty or touched and becomes valid upon change, the error or warning count is decremented and badges are not displayed
If the Check button is clicked, the form is validated. The error and warning cbadges are displayed for all invalid fields and will remain so until the each field respective field becomes valid
If the form is dirty and invalid, the submit button is disabled and the Check button is enabled
If the form is dirty and valid, the submit button is enabled and the Check button is disabled

Input: values - object containing the form state including field values, dirty, touched, error and warning states
Output: errors - object containing the errors and warnings for each field including type, message, error and warning counts

validate is always called when the form is rendered and when the form is updated
the errors object is always rebuilt and returned to the form component
the errors object is used to update the form state and display error and warning messages
validation is bypassed when the form is pristine. The form is pristine when the form is first rendered or when the reset button is clicked
initially the count of errors for mandatory fields should equal mandatoryFieldsArray.length since no field is populated and they must all be populated
warning count should be 0 since no warning fields are populated

*/

const validate = (values) => {
  //console.log('VALIDATE:', values)

  let errors = {};

  //Mandatory fields required and valid in HPLS form v1.6 from AS
  const mandatoryFieldsArray = [
    "p27__first_name",
    "p27__last_name",
    "p27__date_of_birth",
    "p27__phone1",
    "p27__phone1_description",
    "dc118__Problem1",
    "dc118__InstructionsMatterDescription",
  ];

  //Optional fields with validation warnings
  const optionalFieldsArray = ["p27__e_mail", "disabilities_list"];

  //pass through count of total required fields
  errors.mandatoryFieldsCount = mandatoryFieldsArray.length;

  //pass through count of total warning fields
  errors.optionalFieldsCount = optionalFieldsArray.length;

  //Check if the form is pristine globally
  let formIsPristine = values.formTrack ? values.formTrack[0] : true;

  //Check button clicked
  let checkButtonClicked = values.formTrack ? values.formTrack[5] : false;

  //if form is not pristine init all mandatory field error messages to "Required"
  // if (!formIsPristine) {
  //   for (let i=0; i < mandatoryFieldsArray.length; i++) {
  //     errors[mandatoryFieldsArray[i]] = "Required"
  //   }
  // }

  //Get the count of warning fields that are in error
  const countWarnings = (errors) => {
    let count = 0;

    //increment count for each item in optionalFieldsArray that is
    for (let key in errors) {
      //console.log('***WARNING COUNT KEY:', key, 'VALUE:', errors[key], 'WARNING:', optionalFieldsArray.includes(key))
      if (optionalFieldsArray.includes(key) && errors[key] !== undefined) {
        ++count;
      }
    }

    //only update warning count if there are warnings otherwise return 0
    if (count > 0) {
      return count;
    } else {
      return 0;
    }
  };
  //Get the count of mandatory fields that are in error
  const countMandatoryFieldErrors = (errors) => {
    let count = 0;

    //increment count for each item in mandatoryFieldsArray that is
    for (let key in errors) {
      //console.log('***WARNING COUNT KEY:', key, 'VALUE:', errors[key], 'WARNING:', mandatoryFieldsArray.includes(key))
      if (mandatoryFieldsArray.includes(key) && errors[key] !== undefined) {
        ++count;
      }
    }

    //only update mandatory field error count errors exist otherwise return 0 to clear any previous errors
    if (count > 0) {
      return count;
    } else {
      return 0;
    }
  };

  const validDoB = (d, m, y) => {
    //Ask client if further validation for age is required
    //Currently only checking for presence of date of birth values

    // const dob = new Date(y, m-1, d)
    // const age = new Date().getFullYear() - dob.getFullYear()
    // console.log('DOB:', dob, 'AGE:', age)
    // if (age < 18 || age > 123) {
    //   return "Please enter a valid date of birth"
    // }

    if (!d || !m || !y) {
      return false;
    } else {
      return true;
    }
  };

  const dobIsValid = validDoB(
    values.clientDOB_day,
    values.clientDOB_month,
    values.clientDOB_year
  );
  //check for au phone number format -- MORE TO DO HERE
  const validatePhone = (phone) => {
    const phoneRegex = /\b([+-]?\d{2}|\d{4})\s*\(?\d+\)?\s*(?:\d+\s*)+\b/;
    const phoneValid = phoneRegex.test(phone);
    //console.log('Func PHONE VALID:', phoneValid)
    return phoneValid;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(email) || !email.length > 5) {
      return "Providing an email address is optional but when provided, it must be valid";
    }
  };

  // const validateMatterDescription = (matterDescription) => {

  //   // test for the presence of words
  //   const wordsRegex = /((\w+ ){5,})/;
  //   const containsWords = wordsRegex.test(matterDescription);
  //   //console.log('Matter description - VALID: ', containsWords)

  //   //strip spaces and check length
  //   const matterDescriptionLength = matterDescription.replace(/\s/g, '').length;
  //   //console.log('Matter description - LENGTH:',matterDescriptionLength)

  //   if (matterDescriptionLength < 10 || !containsWords) {
  //     return "Please provide more information"
  //   }
  // }

  //the form will become pristine again when the reset button is clicked
  //if the form is not pristine, set mandatory field error messages, and error and warning counts to defaults
  if (formIsPristine && !checkButtonClicked) {
    //

    //if form is pristine, set mandatory field error messages, and error and warning counts to defaults
    for (let i = 0; i < mandatoryFieldsArray.length; i++) {
      errors[mandatoryFieldsArray[i]] = "Required";
    }
    for (let i = 0; i < optionalFieldsArray.length; i++) {
      errors[optionalFieldsArray[i]] = "";
    }
    errors.mandatoryFieldErrorCount = mandatoryFieldsArray.length;
    errors.optionalFieldErrorCount = 0;

    return errors;
  } else if (!formIsPristine || checkButtonClicked) {
    //validate fields if the form is not pristine - any field is dirty
    //reset mandatory field error counts
    errors.mandatoryFieldErrorCount = 0;

    //first set all required fields to "Required" if they are empty
    // for (let i=0; i < mandatoryFieldsArray.length; i++) {
    //   if (!values[mandatoryFieldsArray[i]]) {
    //     errors[mandatoryFieldsArray[i]] = "Required"
    //   }
    // }

    //Mandatory fields
    if (!values.p27__first_name) {
      errors.p27__first_name = "First name is required";
    }

    if (!values.p27__last_name) {
      errors.p27__last_name = "Last name is required";
    }

    if (!dobIsValid) {
      //hidden field p27__date_of_birth is composed of 3 fields
      errors.p27__date_of_birth = "Please enter a date of birth";
    }

    //Phone number validation
    if (values.p27__phone1) {
      //Phone length is number of digits excluding spaces and special characters
      const phoneLength = values.p27__phone1.replace(/(\D\(\))/g, "").length;
      const phoneValid = validatePhone(values.p27__phone1);
      if (!phoneValid) {
        //|| phoneValid === undefined
        errors.p27__phone1 = "The phone number contains invalid characters";
      } else if (phoneLength < 8 || phoneLength > 15) {
        //check if phone number contains at least 8 digits
        errors.p27__phone1 =
          "Please check the number of digits in the phone number";
      }
    } else {
      errors.p27__phone1 = "Phone number is required";
    }

    if (
      !values.p27__phone1_description ||
      values.p27__phone1_description === "" ||
      values.p27__phone1_description === "Please select"
    ) {
      errors.p27__phone1_description =
        "Please select the type of contact number";
    }

    if (!values.dc118__Problems || values.dc118__Problems.length === 0) {
      errors.dc118__Problem1 = "Please select at least one legal issue";
    }

    if (!values.dc118__InstructionsMatterDescription) {
      errors.dc118__InstructionsMatterDescription = "Required";
    }
    // else if (values.dc118__InstructionsMatterDescription) {
    //   errors.dc118__InstructionsMatterDescription = validateMatterDescription(values.dc118__InstructionsMatterDescription);

    // } else {
    //   errors.dc118__InstructionsMatterDescription = undefined
    // }

    if (values.disabilities_list && values.disabilities_list.length > 4) {
      errors.disabilities_list = "Please choose between 1 - 4 items";
    }

    //Optional fields
    if (values.p27__e_mail) {
      errors.p27__e_mail = validateEmail(values.p27__e_mail);
    }
  }

  errors.optionalFieldErrorCount = countWarnings(errors);
  errors.mandatoryFieldErrorCount = countMandatoryFieldErrors(errors);

  //console.log('VALIDATE formTrack:', values.formTrack)

  return errors;
};
export default validate;
